import styled, { css } from 'react-emotion'

export const logo__wrapper__mobile = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
`

export const logo__wrapper__desktop = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
`

export const container__desktop = css`
  background: radial-gradient(50% 100% at 50% 100%, #103b4a 0%, rgba(15, 21, 26, 0.15) 100%);
  margin-top: 0;
  margin-bottom: 0;
  margin-left: -2.4rem;
  margin-right: -2.4rem;
  padding-top: 0;
  padding-bottom: 4rem;
  padding-left: 2.4rem;
  padding-right: 2.4rem;

  h3 {
    color: rgb(203, 203, 203);
    font-size: 1.5rem;
    display: inline-block;
    vertical-align: middle;
    font-weight: 400;
    margin-bottom: 8px;
  }
`

export const container__mobile = css`
  background: radial-gradient(50% 100% at 50% 100%, #103b4a 0%, rgba(15, 21, 26, 0.15) 100%);
  padding: 0 16px 32px 16px;
  // margin-top: -10px;
  // margin-bottom: 24px;
  margin-left: -16px;
  margin-right: -16px;

  h3 {
    color: rgb(203, 203, 203);
    font-size: 15px;
    margin: 0px;
    font-weight: 400;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 8px;
  }
`

export const container__mobile__playlist = css`
  background: radial-gradient(50% 100% at 50% 100%, #103b4a 0%, rgba(15, 21, 26, 0.15) 100%);
  padding: 0px 16px 32px 16px;
  margin-left: -16px;

  h3 {
    color: rgb(203, 203, 203);
    font-size: 15px;
    margin: 0px;
    font-weight: 400;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 8px;
  }
`

export const container__nopad = css`
  padding-top: 0;
  margin-bottom: -6rem;
`

export const container__nopad__mobile = css`
  padding-top: 0;
  margin-bottom: -10px;
`

export const container__withpad = css`
  padding-bottom: 100px;
`

export const container__nobanner = css`
  margin-top: 0;
`

export const link__mobile = css`
  position: relative;
  height: 100%;
  width: calc(100% / 3 - 8px);
  background: linear-gradient(90deg, rgb(31 201 255 / 0.06) 17.61%, rgb(3 111 179 / 5%) 82.39%);
  border-radius: 25px;
  margin: 6px 0px;

  // :first-child {
  //   width: 100%;
  // }

  :nth-child(3n + 2) {
    margin: 6px 8px;
  }
`

export const link__desktop = css`
  position: relative;
  background: linear-gradient(90deg, rgba(31, 201, 255, 0.05) 17.61%, rgba(3, 111, 179, 0.05) 82.39%);
  height: 100%;
  width: calc(100% / 4 - 2rem);
  margin: 1.2rem 1rem;
  border-radius: 9.6rem;
  min-height: 5.8rem;
`

export const border__mobile = css`
  background: linear-gradient(90deg, rgba(31, 201, 255, 0.05) 17.61%, rgba(3, 111, 179, 0.05) 82.39%);
  border: 1px solid rgb(31 201 255 / 0.6);
  border-radius: 25px;
  height: 40px;
`

export const border__desktop = css`
  height: auto;
  width: auto;
  min-height: 5.8rem;
  transition: 0.1s linear;
  border-radius: 9.6rem;
  border: 2px solid #3d535e;
  position: relative;
  display: block;

  :hover {
    border: 2px solid rgb(31 201 255 / 0.8);
    background-repeat: no-repeat;
    background-size: cover;
  }
`

export const logo__mobile = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 100%;
  height: 40px;
  border-radius: 25px;

  > img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    max-height: 35px;
  }
`
export const logo__desktop = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 100%;
  min-height: 5.8rem;
  border-radius: 9.6rem;
  position: relative;
  box-sizing: border-box;

  > img {
    height: 100%;
    width: 100%;
    max-height: 6.5rem;
    object-fit: contain;
  }

  .errorBackground {
    background-size: 60%;
  }
`
export const label__mobile = css`
  height: 50%;
  width: 50%;
  color: #fff;
  background-color: #333739;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const label__desktop = css`
  height: 50%;
  width: 50%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`
